import { Button, useSidebar } from "@EspaceParkQC/sdk-react";
import { PanelLeftCloseIcon, PanelLeftOpenIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function SidebarTrigger(): React.ReactElement {
  const { toggleSidebar, open } = useSidebar();
  const { t } = useTranslation("main");

  return (
    <Button variant="outline" className="w-fit px-2 ml-4 mt-4" size="sm" onClick={toggleSidebar}>
      {open ? <PanelLeftOpenIcon className="size-4" /> : <PanelLeftCloseIcon className="size-4" />}
      <span className="text-sm">{t("sidebar.history")}</span>
    </Button>
  );
}
